// extracted by mini-css-extract-plugin
module.exports = {"commonTableContainer":"style_commonTableContainer__2eKwT"};